module.exports = __webpack_public_path__ + "static/img03-24cdb202b8ee2d10045c822ff623b510.png";